import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { IconModule } from '../icon/icon.module';
import { UtilitiesModule } from '../utilities/utilities.module';


@NgModule({
  declarations: [NavigationComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    IconModule,
    UtilitiesModule
  ],
  exports: [NavigationComponent]
})
export class NavigationModule { }
